const PercentFormat = (totalCount, count) => {
  const data = Math.abs((count / totalCount) * 100).toFixed(0);
  if (isNaN(data)) {
    return 0;
  }
  return Math.abs((count / totalCount) * 100).toFixed(0);
};

export default PercentFormat;
